export default "__VITE_ASSET__MGiR9sYt__"